import { render, staticRenderFns } from "./InfoWidget.vue?vue&type=template&id=73dddfb4&"
import script from "./InfoWidget.vue?vue&type=script&lang=js&"
export * from "./InfoWidget.vue?vue&type=script&lang=js&"
import style0 from "./InfoWidget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports